<template>
  <div class="animated fadeIn">

    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3">
          <router-link :to="'/plannings/guichet/create/'+guichet_id" v-if="can('planning-create')">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-plus"></i>&nbsp;Nouveau
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
     <b-col lg="12">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
          <div>
              <!--<vue-good-table :columns="columns" :rows="rows" :fixed-header="false" :pagination-options="pagination" :search-options="search"/>-->
              <full-calendar :events="events" :config="config">

              </full-calendar>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/locale/fr'
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  //components: {VueGoodTable},
  components: {FullCalendar},
   data(){
    return {
      config: {
        locale: 'fr',
      },
      events: [
        /*{
            title  : 'event1',
            start  : '2018-10-19T12:30:00',
            color: 'red',
            textColor: 'black',
        },
        {
            title  : 'event2',
            start  : '2018-10-19',
            end    : '2018-10-18T',
        },
        {
            title  : 'event3',
            start  : '2018-10-19T14:30:00',
            allDay : false,
        },*/
      ],
      columns: [
        {
          label: 'Montant minimal',
          field: 'montant_min',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Montant maximal',
          field: 'montant_max',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Tarif',
          field: 'tarif',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'DD-MM-YYYY',
          filterable: true,width: '180px',
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Enregistré le',
          field: 'created_at',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'DD-MM-YYYY',
          formatFn: this.formatFn,
          filterable: true,width: '180px',
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Action',
          field: 'btn',
          html: true,
          width: '150px',
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 3,
          position: 'bottom',
          perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        },
        search:{
            enabled: false,
            trigger: 'keyup',
            placeholder: 'Rechercher dans la table',
        },
        guichet_id:''
    };
  },
  // computed: mapState({
  //   agencies: state => state.atm.all
  // }),
  created () {
    
    //this.get_all_planning()
  },
  methods:{
    formatFn: function (value) {
        return value != null ? value : null
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    async get_all_planning(){
      this.guichet_id = this.$route.params.guichet_id
      this.$store.dispatch('planning/get_all_planning_by_guichet',this.$route.params.guichet_id).then(()=>{
        this.events =  store.getters['planning/rows'];
        return this.events
      })
        //return this.events =  store.getters['planning/rows'];
    }
  },
  mounted(){
    this.get_all_planning()
  }
  
}
</script>
